import { render } from "./SchemaSettingsPanel.vue?vue&type=template&id=7ae76bbd&scoped=true"
import script from "./SchemaSettingsPanel.vue?vue&type=script&lang=ts"
export * from "./SchemaSettingsPanel.vue?vue&type=script&lang=ts"

import "./SchemaSettingsPanel.vue?vue&type=style&index=0&id=7ae76bbd&lang=scss"
import "./SchemaSettingsPanel.vue?vue&type=style&index=1&id=7ae76bbd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ae76bbd"

export default script